import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteEra, getEras } from '../../store/actions/era/era.action';
import ErasList from '../../components/Eras/Eras';
import PageLoader from '../../components/Common/PageLoader';

const ErasContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const eras = useSelector((state) => state.era.list);
  const isFetching = useSelector((state) => state.era.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const eraCategory = categories.find((category) => category.link === 'eras');
      if (eraCategory) {
        setMode(eraCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Era category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete era
  const handleDeleteEra = useCallback((era) => {
    dispatch(deleteEra(era));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getEras());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare era info object
  const eraInfo = {
    deleteEra: handleDeleteEra,
    eras
  };

  return (
    <section>
      <ErasList mode={mode} eraInfo={eraInfo} />
    </section>
  );
};

export default ErasContainer;
